import { render, staticRenderFns } from "./set-delivery-unit.vue?vue&type=template&id=7acf54a2&"
import script from "./set-delivery-unit.vue?vue&type=script&lang=js&"
export * from "./set-delivery-unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports